import * as FLAGS from '@travel/icons/flag';

const FLAG_ICONS: {
  [key: string]: any;
} = {
  AFG: FLAGS.Afghanistan,
  ALB: FLAGS.Albania,
  DZA: FLAGS.Algeria,
  ASM: FLAGS.AmericanSamoa,
  AND: FLAGS.Andorra,
  AGO: FLAGS.Angola,
  AIA: FLAGS.Anguilla,
  ATA: FLAGS.Antarctica,
  ATG: FLAGS.AntiguaBarbuda,
  ARG: FLAGS.Argentina,
  ARM: FLAGS.Armenia,
  ABW: FLAGS.Aruba,
  AUS: FLAGS.Australia,
  AUT: FLAGS.Austria,
  AZE: FLAGS.Azerbaijan,
  BHS: FLAGS.Bahamas,
  BHR: FLAGS.Bahrain,
  BGD: FLAGS.Bangladesh,
  BRB: FLAGS.Barbados,
  BLR: FLAGS.Belarus,
  BEL: FLAGS.Belgium,
  BLZ: FLAGS.Belize,
  BEN: FLAGS.Benin,
  BMU: FLAGS.Bermuda,
  BTN: FLAGS.Bhutan,
  BOL: FLAGS.Bolivia,
  BES: FLAGS.Bonaire,
  BIH: FLAGS.Bosnia,
  BWA: FLAGS.Botswana,
  BVT: FLAGS.SvalbardAndJanMayen, // Bouvet Island
  BRA: FLAGS.Brazil,
  IOT: FLAGS.BritishIndianOceanTerritory,
  BRN: FLAGS.Brunei,
  BGR: FLAGS.Bulgaria,
  BFA: FLAGS.BurkinaFaso,
  BDI: FLAGS.Burundi,
  CPV: FLAGS.CaboVerde,
  KHM: FLAGS.Cambodia,
  CMR: FLAGS.Cameroon,
  CAN: FLAGS.Canada,
  CYM: FLAGS.CaymanIslands,
  CAF: FLAGS.CentralAfricanRepublic,
  TCD: FLAGS.Chad,
  CHL: FLAGS.Chile,
  CHN: FLAGS.China,
  CXR: FLAGS.ChristmasIsland,
  CCK: FLAGS.CocosKeelingIslands,
  COL: FLAGS.Colombia,
  COM: FLAGS.Comoros,
  COD: FLAGS.DemocraticRepublicCongo,
  COG: FLAGS.RepublicOfTheCongo,
  COK: FLAGS.CookIslands,
  CRI: FLAGS.CostaRica,
  HRV: FLAGS.Croatia,
  CUB: FLAGS.Cuba,
  CUW: FLAGS.Curacao,
  CYP: FLAGS.Cyprus,
  CZE: FLAGS.CzechRepublic,
  CIV: FLAGS.CoteDivoire,
  DNK: FLAGS.Denmark,
  DJI: FLAGS.Djibouti,
  DMA: FLAGS.Dominica,
  DOM: FLAGS.DominicanRepublic,
  ECU: FLAGS.Ecuador,
  EGY: FLAGS.Egypt,
  SLV: FLAGS.ElSalvador,
  GNQ: FLAGS.EquatorialGuinea,
  ERI: FLAGS.Eritrea,
  EST: FLAGS.Estonia,
  SWZ: FLAGS.Swaziland,
  ETH: FLAGS.Ethiopia,
  FLK: FLAGS.FalklandIsland,
  FRO: FLAGS.FaroeIslands,
  FJI: FLAGS.Fiji,
  FIN: FLAGS.Finland,
  FRA: FLAGS.France,
  GUF: FLAGS.FrenchGuiana,
  PYF: FLAGS.FrenchPolynesia,
  ATF: FLAGS.FrenchSouthernTerritories,
  GAB: FLAGS.Gabon,
  GMB: FLAGS.Gambia,
  GEO: FLAGS.Georgia,
  DEU: FLAGS.Germany,
  GHA: FLAGS.Ghana,
  GIB: FLAGS.Gibraltar,
  GRC: FLAGS.Greece,
  GRL: FLAGS.Greenland,
  GRD: FLAGS.Grenada,
  GUM: FLAGS.Guam,
  GTM: FLAGS.Guatemala,
  GGY: FLAGS.Guernsey,
  GIN: FLAGS.Guinea,
  GNB: FLAGS.GuineaBissau,
  GUY: FLAGS.Guyana,
  HTI: FLAGS.Haiti,
  HMD: FLAGS.HeardIslandAndMcdonaldIslands,
  VAT: FLAGS.VaticanCity,
  HND: FLAGS.Honduras,
  HKG: FLAGS.Hongkong,
  HUN: FLAGS.Hungary,
  ISL: FLAGS.Iceland,
  IND: FLAGS.India,
  IDN: FLAGS.Indonesia,
  IRN: FLAGS.Iran,
  IRQ: FLAGS.Iraq,
  IRL: FLAGS.Ireland,
  IMN: FLAGS.IsleOfMan,
  ISR: FLAGS.Israel,
  ITA: FLAGS.Italy,
  JAM: FLAGS.Jamaica,
  JPN: FLAGS.Japan,
  JEY: FLAGS.Jersey,
  JOR: FLAGS.Jordan,
  KAZ: FLAGS.Kazakhstan,
  KEN: FLAGS.Kenya,
  KIR: FLAGS.Kiribati,
  PRK: FLAGS.NorthKorea,
  KOR: FLAGS.SouthKorea,
  KWT: FLAGS.Kuwait,
  KGZ: FLAGS.Kyrgyzstan,
  LAO: FLAGS.Laos,
  LVA: FLAGS.Latvia,
  LBN: FLAGS.Lebanon,
  LSO: FLAGS.Lesotho,
  LBR: FLAGS.Liberia,
  LBY: FLAGS.Libya,
  LIE: FLAGS.Liechtenstein,
  LTU: FLAGS.Lithuania,
  LUX: FLAGS.Luxembourg,
  MAC: FLAGS.Macao,
  MDG: FLAGS.Madagascar,
  MWI: FLAGS.Malawi,
  MYS: FLAGS.Malaysia,
  MDV: FLAGS.Maldives,
  MLI: FLAGS.Mali,
  MLT: FLAGS.Malta,
  MHL: FLAGS.MarshallIslands,
  MTQ: FLAGS.Martinique,
  MRT: FLAGS.Mauritania,
  MUS: FLAGS.Mauritius,
  MYT: FLAGS.Mayotte,
  MEX: FLAGS.Mexico,
  FSM: FLAGS.Micronesia,
  MDA: FLAGS.Moldova,
  MCO: FLAGS.Monaco,
  MNG: FLAGS.Mongolia,
  MNE: FLAGS.Montenegro,
  MSR: FLAGS.Montserrat,
  MAR: FLAGS.Morocco,
  MOZ: FLAGS.Mozambique,
  MMR: FLAGS.Myanmar,
  NAM: FLAGS.Namibia,
  NRU: FLAGS.Nauru,
  NPL: FLAGS.Nepal,
  NLD: FLAGS.Netherlands,
  NCL: FLAGS.NewCaledonia,
  NZL: FLAGS.NewZealand,
  NIC: FLAGS.Nicaragua,
  NER: FLAGS.Niger,
  NGA: FLAGS.Nigeria,
  NIU: FLAGS.Niue,
  NFK: FLAGS.NorfolkIsland,
  MNP: FLAGS.NorthernMarianaIslands,
  NOR: FLAGS.Norway,
  OMN: FLAGS.Oman,
  PAK: FLAGS.Pakistan,
  PLW: FLAGS.Palau,
  PSE: FLAGS.Palestine,
  PAN: FLAGS.Panama,
  PNG: FLAGS.PapuaNewGuinea,
  PRY: FLAGS.Paraguay,
  PER: FLAGS.Peru,
  PHL: FLAGS.Philippines,
  PCN: FLAGS.Pitcairn,
  POL: FLAGS.Poland,
  PRT: FLAGS.Portugal,
  PRI: FLAGS.PuertoRico,
  QAT: FLAGS.Qatar,
  MKD: FLAGS.Macedonia,
  ROU: FLAGS.Romania,
  RUS: FLAGS.Russia,
  RWA: FLAGS.Rwanda,
  REU: FLAGS.Reunion,
  BLM: FLAGS.SaintBarthelemy,
  SHN: FLAGS.SaintHelenaAscensionAndTristanDaCunha,
  KNA: FLAGS.SaintKittsNevis,
  LCA: FLAGS.SaintLucia,
  MAF: FLAGS.SaintMartin,
  SPM: FLAGS.SaintPierreAndMiquelon,
  VCT: FLAGS.SaintVincentGrenadines,
  WSM: FLAGS.Samoa,
  SMR: FLAGS.SanMarino,
  STP: FLAGS.SaoTomePrincipe,
  SAU: FLAGS.SaudiArabia,
  SEN: FLAGS.Senegal,
  SRB: FLAGS.Serbia,
  SYC: FLAGS.Seychelles,
  SLE: FLAGS.SierraLeone,
  SGP: FLAGS.Singapore,
  SXM: FLAGS.SintMaarten,
  SVK: FLAGS.Slovakia,
  SVN: FLAGS.Slovenia,
  SLB: FLAGS.SolomonIslands,
  SOM: FLAGS.Somalia,
  ZAF: FLAGS.SouthAfrica,
  SGS: FLAGS.SouthGeorgiaAndTheSouthSandwichIslands,
  SSD: FLAGS.SouthSudan,
  ESP: FLAGS.Spain,
  LKA: FLAGS.SriLanka,
  SDN: FLAGS.Sudan,
  SUR: FLAGS.Suriname,
  SJM: FLAGS.SvalbardAndJanMayen,
  SWE: FLAGS.Sweden,
  CHE: FLAGS.Switzerland,
  SYR: FLAGS.Syria,
  TWN: FLAGS.Taiwan,
  TJK: FLAGS.Tajikistan,
  TZA: FLAGS.Tanzania,
  THA: FLAGS.Thailand,
  TLS: FLAGS.TimorLeste,
  TGO: FLAGS.Togo,
  TKL: FLAGS.Tokelau,
  TON: FLAGS.Tonga,
  TTO: FLAGS.TrinidadTobago,
  TUN: FLAGS.Tunisia,
  TUR: FLAGS.Turkey,
  TKM: FLAGS.Turkmenistan,
  TCA: FLAGS.TurksAndCaicosIslands,
  TUV: FLAGS.Tuvalu,
  UGA: FLAGS.Uganda,
  UKR: FLAGS.Ukraine,
  ARE: FLAGS.UnitedArabEmirates,
  GBR: FLAGS.UnitedKingdom,
  UMI: FLAGS.UnitedStatesMinorOutlyingIslands,
  USA: FLAGS.Usa,
  URY: FLAGS.Uruguay,
  UZB: FLAGS.Uzbekistan,
  VUT: FLAGS.Vanuatu,
  VEN: FLAGS.Venezuela,
  VNM: FLAGS.Vietnam,
  VGB: FLAGS.VirginIslandsUk,
  VIR: FLAGS.VirginIslandsUs,
  WLF: FLAGS.WallisAndFutuna,
  ESH: FLAGS.WesternSahara,
  YEM: FLAGS.Yemen,
  ZMB: FLAGS.Zambia,
  ZWE: FLAGS.Zimbabwe,
  ALA: FLAGS.AlandIslands,
  GLP: FLAGS.Guadeloupe,

  // Below contries are needed to be updated with alpha-3 country code
  PS: null,
  CS: null,
};

export default FLAG_ICONS;
